import { HistoricOrder } from 'olo-service';
import { useColoResource } from './useColoResource';

export function useCustomerOrders(merchantId?: string, sessionId?: string, shouldFetch?: boolean) {

  const [loading, data, error] = useColoResource<HistoricOrder[]>(() => shouldFetch && sessionId && merchantId && ({
    url: `${merchantId}/customers/current/orders`,
    headers: {
      'X-Clover-Customer-Auth': sessionId
    }
  }), [sessionId, merchantId]);

  return { loading, orders: data, error };
}
